const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Time {
    constructor(runtime) { this.runtime = runtime; this._timers = {}; }
    getInfo() {
        return {
            id: 'timeExt', name: '⏰ 時間', color1: '#4C97FF', color2: '#3D79CC',
            blocks: [
                { opcode: 'year', blockType: BlockType.REPORTER, text: '年' },
                { opcode: 'month', blockType: BlockType.REPORTER, text: '月' },
                { opcode: 'day', blockType: BlockType.REPORTER, text: '日' },
                { opcode: 'weekday', blockType: BlockType.REPORTER, text: '曜日' },
                { opcode: 'hour', blockType: BlockType.REPORTER, text: '時' },
                { opcode: 'minute', blockType: BlockType.REPORTER, text: '分' },
                { opcode: 'second', blockType: BlockType.REPORTER, text: '秒' },
                { opcode: 'ms', blockType: BlockType.REPORTER, text: 'ミリ秒' },
                { opcode: 'timestamp', blockType: BlockType.REPORTER, text: 'タイムスタンプ' },
                { opcode: 'startTimer', blockType: BlockType.COMMAND, text: 'タイマー [N] 開始', arguments: { N: { type: ArgumentType.STRING, defaultValue: 't1' } } },
                { opcode: 'getTimer', blockType: BlockType.REPORTER, text: 'タイマー [N] の値', arguments: { N: { type: ArgumentType.STRING, defaultValue: 't1' } } },
                { opcode: 'wait', blockType: BlockType.COMMAND, text: '[MS] ミリ秒待つ', arguments: { MS: { type: ArgumentType.NUMBER, defaultValue: 100 } } }
            ]
        };
    }
    year() { return new Date().getFullYear(); }
    month() { return new Date().getMonth() + 1; }
    day() { return new Date().getDate(); }
    weekday() { return ['日','月','火','水','木','金','土'][new Date().getDay()]; }
    hour() { return new Date().getHours(); }
    minute() { return new Date().getMinutes(); }
    second() { return new Date().getSeconds(); }
    ms() { return new Date().getMilliseconds(); }
    timestamp() { return Date.now(); }
    startTimer(args) { this._timers[args.N] = Date.now(); }
    getTimer(args) { return this._timers[args.N] ? (Date.now() - this._timers[args.N]) / 1000 : 0; }
    wait(args) { return new Promise(function(r) { setTimeout(r, Cast.toNumber(args.MS)); }); }
}
module.exports = Scratch3Time;